import { render, staticRenderFns } from "./GenreModal.vue?vue&type=template&id=a5ab0442&scoped=true&"
import script from "./GenreModal.vue?vue&type=script&lang=js&"
export * from "./GenreModal.vue?vue&type=script&lang=js&"
import style0 from "./GenreModal.vue?vue&type=style&index=0&id=a5ab0442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ab0442",
  null
  
)

export default component.exports